"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * Upload icon - represents file upload action.
 * Used in import/upload interfaces.
 */
var Upload = function Upload(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    fill: "none"
  }, props), (0, _preact.h)("path", {
    d: "M64.5 33.4667C62.2333 21.9667 52.1333 13.3333 40 13.3333C30.3667 13.3333 22 18.8 17.8333 26.8C7.8 27.8667 0 36.3667 0 46.6667C0 57.7 8.96667 66.6667 20 66.6667H63.3333C72.5333 66.6667 80 59.2 80 50C80 41.2 73.1667 34.0667 64.5 33.4667ZM46.6667 43.3333V56.6667H33.3333V43.3333H23.3333L40 26.6667L56.6667 43.3333H46.6667Z",
    fill: "currentColor"
  }));
};

var _default = Upload;
exports.default = _default;